/* eslint-disable no-console */

import { v4 as uuidv4 } from 'uuid';

let currentSessionId;

export default function sessionID() {
  if (currentSessionId) {
    return currentSessionId;
  }

  // Try to load from localStorage
  try {
    currentSessionId = global.window.localStorage.getItem('sessionID');
  } catch (e) {
    console.error('Error getting existing sessionID', e);
  }

  if (currentSessionId) {
    return currentSessionId;
  }

  // Generate a new session ID
  currentSessionId = uuidv4();

  try {
    global.window.localStorage.setItem('sessionID', currentSessionId);
  } catch (e) {
    console.error('Error setting sessionID', e);
  }

  return currentSessionId;
}
